import React from 'react'
import { add as addToCart } from '../../../Services/Cart.service';
import {
    receive as receiveCart,
} from '../../../Actions/Cart.action';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../../Hooks/useTypedSelector';
import { translate } from '../../../Services/translation';
import Icon from '../../Icon';
import { ADD_TO_CART_CLICK_SOURCE, SUGGESTED_PRODUCT_SECTION } from '../../../constants';
import Button from '../../Button';
import { reloadPayment } from '../../../Actions/Checkout.action';

const AddSuggestedProductToCartButton = ({ articleNumber, brandTrackingSource, email, usedIn, btnSize, className = "" }) => {
    const dispatch = useDispatch();
    const orderRows = useTypedSelector((state) => state.cart.orderRows)
    const clickSource = () => {
        
        let prefix = ""
        if(brandTrackingSource)
            prefix = brandTrackingSource + "_"
        
        switch (usedIn) {
            case SUGGESTED_PRODUCT_SECTION.Checkout:
                return prefix + ADD_TO_CART_CLICK_SOURCE.CheckOut
            case SUGGESTED_PRODUCT_SECTION.Minicart:
                return prefix + ADD_TO_CART_CLICK_SOURCE.MiniCart
            default:
                return null
        }
    }
    const handleAddSuggestedProductToCart = async (e) => {
        e.preventDefault();
        try {
            const cart = await addToCart({ articleNumber, email, clickSource: clickSource() });
            await dispatch(receiveCart(cart));
            await dispatch(reloadPayment());
        } catch (err) {
            console.error('Error adding product to cart from suggested product:', err);
        }
    };

    const isAdded = orderRows.some(row => row.articleNumber === articleNumber);

    return (
        <Button
            btnType={`${isAdded ? "secondary" : "primary"}`}
            btnSize={btnSize}
            className={`tracking-buttons disabled:opacity-100 ${className}`}
            onClick={handleAddSuggestedProductToCart}
            disabled={isAdded ? true : false}
        >
            {isAdded ?
                translate('suggestedproducts-added-btn-text')
                :
                <span className='flex items-center justify-center gap-1'>
                    <Icon name='plus' className=''></Icon>
                    {translate('suggestedproducts-add-btn-text')}
                </span>
            }
        </Button>
    )
}

export default AddSuggestedProductToCartButton